export class RenderedHtml {
  readonly #value: string;

  private constructor(value: string) {
    this.#value = value;
  }

  static of(value: string): RenderedHtml {
    return new RenderedHtml(value);
  }

  get value(): string {
    return this.#value;
  }
}
